import {CommentBox, type CommentBoxHandle, type CommentBoxProps} from '@github-ui/comment-box/CommentBox'
import type React from 'react'

import type {DiffRange} from '../../types'
import {useCommentBoxSubject} from './use-comment-box-subject'

export type ConversationCommentBoxHandle = CommentBoxHandle

export type ConversationCommentBoxProps = Omit<
  CommentBoxProps,
  'children' | 'body' | 'subject' | 'showLabel' | 'placeholder'
> & {
  children?: React.ReactNode
  label: string
  value: string
  ref?: React.Ref<ConversationCommentBoxHandle>
  comparisonRange?: DiffRange
  /** Where is this component being used? */
  surface: 'review' | 'issue_comment' | 'description'
}

export const ConversationCommentBox = ({
  ref,
  children,
  comparisonRange,
  surface,
  ...rest
}: ConversationCommentBoxProps) => {
  return (
    <CommentBox
      {...rest}
      ref={ref}
      placeholder="Leave a comment"
      actions={children}
      subject={useCommentBoxSubject({surface, comparisonRange})}
      showLabel={false}
    />
  )
}

ConversationCommentBox.displayName = 'ConversationCommentBox'
